import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel } from './utils/metaPixel';
import { CurrencyProvider } from './contexts/CurrencyContext';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CurrencyProvider data-id="element-0">
      <SalesPage data-id="element-1" />
    </CurrencyProvider>;
}